import slice from './reports.slice'

export const selectSlice = (state) => state[slice.name]

export const selectTotals = (state) => selectSlice(state).totals
export const selectCommission = (state) => selectSlice(state).commission

export const selectUnengagedUsers = (state) => selectSlice(state).unengagedUsers

export const selectAccountUsers = (state) => selectSlice(state).accountUsers

export const selectChurnedCustomers = (state) =>
	selectSlice(state).churnedCustomers

export const selectProductMix = (state) => selectSlice(state).productMix

export const selectFilters = (state) => selectSlice(state).filters

export const selectEngagementChart = (state) =>
	selectSlice(state).engagementChart

export const selectTotalsAdditional = (state) =>
	selectSlice(state).totalsAdditional

export const selectSelectedAdditionalDataModal = (state) =>
	selectSlice(state).selectedAdditionalDataModal

export const selectCommissionsAdditional = (state) =>
	selectSlice(state).commissionsAdditional
export const selectCommissionsAdditionalType = (state) =>
	selectSlice(state).commissionsAdditionalType

export const selectAdditionalModal = (state) =>
	selectSlice(state).aditionalModal

export const selectPreviousFilters = (state) =>
	selectSlice(state).previousFilters

export const selectStores = (state) => selectSlice(state).stores

export const selectReportCustomers = (state) =>
	selectSlice(state).reportCustomers

export const selectIsDateSelected = (state) => selectSlice(state).isDateSelected

export const selectCloudReport = (state) => selectSlice(state).CloudReport

export const selectCloudTiers = (state) => selectSlice(state).CloudTiers
export const selectCloudReportFilters = (state) =>
	selectSlice(state).cloudReportFilters
